import Page from './Page';
import Component from 'vue-class-component';

import template from './GratuityConfirm.vue.html';

import HeaderComponent from './Header.vue';

import { GratuityStaffImage } from '../common/gratuity/Types';

import { ReservesRoom } from './app';
@Component({ template, components: { HeaderComponent } })
export default class GratuityConfirm extends Page {
    private key = 'GratuityCart';
    comment: string = '';
    amount: number = 0;
    selectRoom: ReservesRoom | null = null;
    isProcessing: boolean = false;

    get gratuityStaff(): any | null {
        const id = Number(this.app.query.staff_id);
        return this.app.gratuity.staffs.find((m) => m.id === id) ?? null;
    }

    get images(): readonly GratuityStaffImage[] {
        const item = this.gratuityStaff;
        if (!item) return [];
        return item.image_urls.map((url: string) => ({
            id: item.id,
            name: item.name,
            filepath: url,
        }));
    }

    async created() {
        await this.app.fetchGratuities();
        window.scroll(0, 0);
        const itemStr = localStorage.getItem(
            `Mypage:${this.key}:${this.app.reserve?.id}:${this.app.query.staff_id}`
        );
        const item: {
            amount: number;
            comment: string;
            select_room_id: number;
        } | null = itemStr ? JSON.parse(itemStr) : null;
        if (item && item.amount > 0) {
            this.amount = item.amount;
        }
        if (item && item.comment.length > 0) {
            this.comment = item.comment;
        }
        if (item && item.select_room_id > 0) {
            this.selectRoom = this.app.reserves_rooms.filter(
                (room) => room.id === item.select_room_id
            )[0];
        }
    }

    async makePayment() {
        if (this.isProcessing || !this.amount) return;
        this.isProcessing = true;
        const [result, _] = await Promise.all([
            this.app.post('gratuity-payment', {
                reserveRoomId: this.selectRoom
                    ? this.selectRoom.id
                    : this.app.reserves_rooms[0].id,
                settingId: this.app.gratuity.id,
                staffId: this.gratuityStaff.id,
                amount: this.amount,
                comment: this.comment,
            }),
            this.app.fetchInfo(),
        ]);
        if (!result.succeed) {
            alert(result.error ? this._(result.error.message_code) : 'Error');
            return;
        } else {
            localStorage.removeItem(
                `Mypage:${this.key}:${this.app.reserve?.id}:${this.app.query.staff_id}`
            );
            alert(this._('gratuity_payment_success'));
            this.app.setPage('Terminal');
            this.isProcessing = false;
        }
        this.$forceUpdate();
    }
}
